/* =====================================================
   Permission catalog (generated — do not edit by hand)
   Source: account-microservice security-config.json + common-library
   PermissionConstants. Regenerate with generate-constants.py when the catalog changes.

   PERMISSIONS:        KEY → permission ID (use the KEY in bm-requires / can())
   PERMISSION_LABELS:  permission ID → display name (tooltips)
   ===================================================== */
angular.module('bizmetryApp')
  .constant('PERMISSIONS', {
    ACTIVATE_ACCOUNT:                       'permission-activate-account',
    ACTIVATE_USER:                          'permission-activate-user',
    AC_PUBLISH:                             'ac-permission-publish',
    AC_RETIRE:                              'ac-permission-retire',
    AC_REVIEW_APPROVE:                      'ac-permission-review-approve',
    AC_REVIEW_REJECT:                       'ac-permission-review-reject',
    AC_SUBMIT_FOR_REVIEW:                   'ac-permission-submit-review',
    AGENT_HEARTBEAT:                        'permission-agent-heartbeat',
    AGENT_PING:                             'permission-agent-ping',
    AGENT_UPLOAD_METRICS:                   'permission-agent-upload-metrics',
    BIZ_EVENT_APPROVE:                      'permission-biz-event-approve',
    BIZ_EVENT_PUBLISH:                      'permission-biz-event-publish',
    BIZ_EVENT_REJECT:                       'permission-biz-event-reject',
    BIZ_EVENT_RETIRE:                       'permission-biz-event-retire',
    BIZ_EVENT_SUBMIT_FOR_REVIEW:            'permission-biz-event-submit-for-review',
    BROWSE_RESOURCES:                       'permission-browse-resources',
    COMPARE_TEMPLATE_VERSION:               'permission-compare-template-version',
    CONNECT_AGENT:                          'permission-connect-agent',
    CREATE_ACCOUNT:                         'permission-create-account',
    CREATE_AGENT:                           'permission-create-agent',
    CREATE_ANY_ROLE:                        'permission-create-any-role',
    CREATE_ANY_SERVICE_ACCOUNT:             'permission-create-any-service-account',
    CREATE_ANY_USER:                        'permission-create-any-user',
    CREATE_API_COLLECTION:                  'permission-create-api-collection',
    CREATE_BIZ_EVENT:                       'permission-create-biz-event',
    CREATE_BIZ_INTERCEPTOR:                 'permission-create-biz-interceptor',
    CREATE_CLIENT:                          'permission-create-client',
    CREATE_DATASOURCE:                      'permission-create-datasource',
    CREATE_ENVIRONMENT:                     'permission-create-environment',
    CREATE_HISTOGRAM:                       'permission-create-histogram',
    CREATE_KPI:                             'permission-create-kpi',
    CREATE_PROFILE:                         'permission-create-profile',
    CREATE_REPORT:                          'permission-create-report',
    CREATE_RESOURCE:                        'permission-create-resource',
    CREATE_ROLE:                            'permission-create-role',
    CREATE_SERVICE_ACCOUNT:                 'permission-create-service-account',
    CREATE_TEMPLATE_VERSION:                'permission-create-template-version',
    CREATE_USER:                            'permission-create-user',
    DATASOURCE_CONNECT:                     'permission-datasource-connect',
    DATASOURCE_EXECUTE:                     'permission-datasource-execute',
    DB_LIST_ATTRIBUTES:                     'permission-list-db-attributes',
    DB_LIST_ENTITIES:                       'permission-list-db-entities',
    DB_LIST_SCHEMAS:                        'permission-list-db-schemas',
    DB_PULL_DATA:                           'permission-pull-db-data',
    DB_TEST_CONNECTION:                     'permission-db-test-connection',
    DELETE_ACCOUNT:                         'permission-delete-account',
    DELETE_AGENT:                           'permission-delete-agent',
    DELETE_AGENT_METRICS:                   'permission-delete-agent-metrics',
    DELETE_ANY_ACCOUNT:                     'permission-delete-any-account',
    DELETE_ANY_API_COLLECTION:              'permission-delete-any-api-collection',
    DELETE_ANY_CLIENT:                      'permission-delete-any-client',
    DELETE_ANY_RESOURCE:                    'permission-delete-any-resource',
    DELETE_ANY_ROLE:                        'permission-delete-any-role',
    DELETE_ANY_SERVICE_ACCOUNT:             'permission-delete-any-service-account',
    DELETE_ANY_USER:                        'permission-delete-any-user',
    DELETE_API_COLLECTION:                  'permission-delete-api-collection',
    DELETE_BIZ_EVENT:                       'permission-delete-biz-event',
    DELETE_BIZ_INTERCEPTOR:                 'permission-delete-biz-interceptor',
    DELETE_BIZ_INTERCEPTOR_BULK:            'permission-delete-biz-interceptor-bulk',
    DELETE_BULK_CLIENT:                     'permission-delete-bulk-client',
    DELETE_BULK_RESOURCES:                  'permission-delete-bulk-resource',
    DELETE_CLIENT:                          'permission-delete-client',
    DELETE_DATASOURCE:                      'permission-delete-datasource',
    DELETE_ENVIRONMENT:                     'permission-delete-environment',
    DELETE_HISTOGRAM:                       'permission-delete-histogram',
    DELETE_KPI:                             'permission-delete-kpi',
    DELETE_PROFILE:                         'permission-delete-profile',
    DELETE_REPORT:                          'permission-delete-report',
    DELETE_RESOURCE:                        'permission-delete-resource',
    DELETE_ROLE:                            'permission-delete-role',
    DELETE_SERVICE_ACCOUNT:                 'permission-delete-service-account',
    DELETE_TEMPLATE_CASCADE:                'permission-delete-template-cascade',
    DELETE_TEMPLATE_VERSION:                'permission-delete-template-version',
    DELETE_USER:                            'permission-delete-user',
    DOWNLOAD_AGENT:                         'permission-download-agent',
    DOWNLOAD_BIZ_INTERCEPTOR_ARTIFACT:      'permission-download-biz-interceptor-artifact',
    DOWNLOAD_BIZ_INTERCEPTOR_ARTIFACT_BULK: 'permission-download-biz-interceptor-artifact-bulk',
    DOWNLOAD_BIZ_INTERCEPTOR_CONFIGURATION: 'permission-download-biz-interceptor-configuration',
    EDIT_ACCOUNT:                           'permission-edit-account',
    EDIT_AGENT:                             'permission-edit-agent',
    EDIT_ANY_ACCOUNT:                       'permission-edit-any-account',
    EDIT_ANY_ROLE:                          'permission-edit-any-role',
    EDIT_API_COLLECTION:                    'permission-edit-api-collection',
    EDIT_CLIENT:                            'permission-edit-client',
    EDIT_DATASOURCE:                        'permission-edit-datasource',
    EDIT_ENVIRONMENT:                       'permission-edit-environment',
    EDIT_KPI:                               'permission-edit-kpi',
    EDIT_PROFILE:                           'permission-edit-profile',
    EDIT_RESOURCE:                          'permission-edit-resource',
    EDIT_ROLE:                              'permission-edit-role',
    EDIT_SERVICE_ACCOUNT:                   'permission-edit-service-account',
    EDIT_TEMPLATE_ATTRIBUTES:               'permission-edit-template-attributes',
    EDIT_TEMPLATE_CLIENT:                   'permission-edit-template-client',
    EDIT_TEMPLATE_RESOURCE:                 'permission-edit-template-resource',
    EDIT_TEMPLATE_VERSION:                  'permission-edit-template-version',
    EDIT_USER:                              'permission-edit-user',
    EDIT_USER_PROFILE:                      'permission-edit-user-profile',
    EXECUTE_INTELLISENSE_PERMISSION:        'execute-intellisense-permission',
    EXPORT_PROFILE:                         'permission-export-profile',
    FETCH_SWAGGER:                          'permission-fetch-swagger',
    GET_AGENT_DETAILS:                      'permission-get-details-agent',
    GET_AGENT_RUNTIME_INFO:                 'permission-get-agent-runtime-info',
    GET_ALL_USERS:                          'permission-get-all-users',
    GET_PERMISSIONS:                        'permission-get-permissions',
    GET_RUNTIME_INFO_AGENT:                 'permission-get-runtime-info-agent',
    IMPORT_PROFILE:                         'permission-import-profile',
    INTERCEPTOR_INIT_PERMISSION:            'permission-interceptor-init',
    INTERCEPTOR_SYNC_PERMISSION:            'permission-interceptor-sync',
    IPAPI_REMOTE_GEOLOCATION:               'permission-ipapi-remote-geolocation',
    LIST_AGENT:                             'permission-list-agent',
    MANAGE_ANY_ROLE_PERMISSIONS:            'permission-manage-any-role-permissions',
    MANAGE_ROLE_PERMISSIONS:                'permission-manage-role-permissions',
    PING_AGENT:                             'permission-ping-agent',
    QUERY_DATA:                             'permission-query-data',
    READ_BMEL_FUNCTIONS:                    'permission-read-bmel-functions',
    RESEND_CONFIRMATION_EMAIL:              'permission-resend-confirmation-email',
    RESTART_AGENT:                          'permission-restart-agent',
    RUN_REPORT:                             'permission-run-report',
    SA_LOGIN:                               'permission-sa-login',
    SA_LOGOUT:                              'permission-sa-logout',
    SEND_EMAIL:                             'permission-send-email',
    SEND_SMS:                               'permission-send-sms',
    SMS_2FA_TOKEN_GENERATION:               'permission-2fa-token-generation-sms',
    SMS_2FA_TOKEN_VALIDATION:               'permission-2fa-token-validation-sms',
    STOP_AGENT:                             'permission-stop-agent',
    SYNC_AGENT:                             'permission-sync-agent',
    TOGGLE_ALL_USERS:                       'permission-toggle-all-users',
    TV_PUBLISH:                             'tv-permission-publish',
    TV_RETIRE:                              'tv-permission-retire',
    TV_REVIEW_APPROVE:                      'tv-permission-review-approve',
    TV_REVIEW_REJECT:                       'tv-permission-review-reject',
    TV_SUBMIT_FOR_REVIEW:                   'tv-permission-submit-review',
    UPDATE_BIZ_EVENT:                       'permission-update-biz-event',
    UPDATE_BIZ_INTERCEPTOR:                 'permission-update-biz-interceptor',
    USER_LOGIN:                             'permission-user-login',
    USER_LOGOUT:                            'permission-user-logout',
    VIEW_ACCOUNT:                           'permission-view-account',
    VIEW_AGENT_LOGS:                        'permission-view-agent-logs',
    VIEW_AGENT_METRICS:                     'permission-view-agent-metrics',
    VIEW_AGENT_PANEL:                       'permission-view-agent-panel',
    VIEW_ALL_NOTIFICATIONS:                 'permission-view-all-notification',
    VIEW_ANY_ACCOUNT:                       'permission-view-any-account',
    VIEW_ANY_API_COLLECTION:                'permission-view-any-api-collection',
    VIEW_ANY_PROFILE:                       'permission-view-any-profile',
    VIEW_ANY_ROLE:                          'permission-view-any-role',
    VIEW_ANY_SERVICE_ACCOUNT:               'permission-view-any-service-account',
    VIEW_ANY_TEMPLATE:                      'permission-view-any-template',
    VIEW_API_COLLECTION:                    'permission-view-api-collection',
    VIEW_BIZ_EVENT:                         'permission-view-biz-event',
    VIEW_BIZ_INTERCEPTOR:                   'permission-view-biz-interceptor',
    VIEW_CLIENT:                            'permission-view-client',
    VIEW_DATASOURCE:                        'permission-view-datasource',
    VIEW_FULL_PROFILE:                      'permission-view-full-profile',
    VIEW_NOTIFICATION:                      'permission-view-notification',
    VIEW_PROFILE:                           'permission-view-profile',
    VIEW_REPORT:                            'permission-view-report',
    VIEW_RESOURCE:                          'permission-view-resource',
    VIEW_ROLE:                              'permission-view-role',
    VIEW_SERVICE_ACCOUNT:                   'permission-view-service-account',
    VIEW_SYSTEM_JOB:                        'permission-view-system-job',
    VIEW_SYSTEM_JOB_DETAILS:                'permission-view-system-job-details',
    VIEW_TEMPLATE:                          'permission-view-template',
    VIEW_TEMPLATE_HIERARCHY:                'permission-view-template-hierarchy',
    VIEW_USER:                              'permission-view-user',
    VIEW_USER_PROFILE:                      'permission-view-user-profile'
  })
  .constant('PERMISSION_LABELS', {
    'permission-activate-account': "Activate Account",
    'permission-activate-user': "Activate User",
    'ac-permission-publish': "AC Publish",
    'ac-permission-retire': "AC Retire",
    'ac-permission-review-approve': "AC Approve Review",
    'ac-permission-review-reject': "AC Reject Review",
    'ac-permission-submit-review': "AC Submit for Review",
    'permission-agent-heartbeat': "Heartbeat Agent",
    'permission-agent-ping': "Ping Remote Agent",
    'permission-agent-upload-metrics': "Upload Captured Metrics to Agent",
    'permission-biz-event-approve': "Approve a business event",
    'permission-biz-event-publish': "Publish a business event",
    'permission-biz-event-reject': "Reject a business event",
    'permission-biz-event-retire': "Retire a business event",
    'permission-biz-event-submit-for-review': "Submit a business event for review",
    'permission-browse-resources': "Browse Resources",
    'permission-compare-template-version': "Compare Template Versions",
    'permission-connect-agent': "Connect Agent",
    'permission-create-account': "Create Account",
    'permission-create-agent': "Create Agent",
    'permission-create-any-role': "Create Any Role",
    'permission-create-any-service-account': "Create Any Service Account",
    'permission-create-any-user': "Create Any User",
    'permission-create-api-collection': "Create Api Collection",
    'permission-create-biz-event': "Create Business Event",
    'permission-create-biz-interceptor': "Create Biz Interceptor",
    'permission-create-client': "Create Client",
    'permission-create-datasource': "Create Datasource",
    'permission-create-environment': "Create Environment",
    'permission-create-histogram': "Create Histogram",
    'permission-create-kpi': "Create KPI",
    'permission-create-profile': "Create Profile",
    'permission-create-report': "Create Report",
    'permission-create-resource': "Create Resource",
    'permission-create-role': "Create Role",
    'permission-create-service-account': "Create Service Account",
    'permission-create-template-version': "Create Template Version",
    'permission-create-user': "Create User",
    'permission-datasource-connect': "Datasource Connect",
    'permission-datasource-execute': "Datasource Execute",
    'permission-list-db-attributes': "List DB Entity Attributes",
    'permission-list-db-entities': "List DB Entities",
    'permission-list-db-schemas': "List DB Schemas",
    'permission-pull-db-data': "Pull DB Data",
    'permission-db-test-connection': "Test Connection",
    'permission-delete-account': "Delete Account",
    'permission-delete-agent': "Delete Agent",
    'permission-delete-agent-metrics': "Delete Agent Metrics",
    'permission-delete-any-account': "Delete Any Account",
    'permission-delete-any-api-collection': "Delete Any Api Collection",
    'permission-delete-any-client': "Delete Any Client",
    'permission-delete-any-resource': "Delete Any Resource",
    'permission-delete-any-role': "Delete Any Role",
    'permission-delete-any-service-account': "Delete Any Service Account",
    'permission-delete-any-user': "Delete Any User",
    'permission-delete-api-collection': "Delete Api Collection",
    'permission-delete-biz-event': "Delete Business Event",
    'permission-delete-biz-interceptor': "Delete Biz Interceptor",
    'permission-delete-bulk-client': "Delete Bulk Client",
    'permission-delete-bulk-resource': "Delete Bulk Resource",
    'permission-delete-client': "Delete Client",
    'permission-delete-datasource': "Delete Datasource",
    'permission-delete-environment': "Delete Environment",
    'permission-delete-histogram': "Delete Histogram",
    'permission-delete-kpi': "Delete KPI",
    'permission-delete-profile': "Delete Profile",
    'permission-delete-report': "Delete Report",
    'permission-delete-resource': "Delete Resource",
    'permission-delete-role': "Delete Role",
    'permission-delete-service-account': "Delete Service Account",
    'permission-delete-template-cascade': "Delete Template Cascade",
    'permission-delete-template-version': "Delete Template Version",
    'permission-delete-user': "Delete User",
    'permission-download-agent': "Download Agent",
    'permission-download-biz-interceptor-artifact': "Download Biz Interceptor Artifact",
    'permission-download-biz-interceptor-configuration': "Download Biz Interceptor Configuration",
    'permission-edit-account': "Edit Account",
    'permission-edit-agent': "Edit Agent",
    'permission-edit-any-account': "Edit Any Account",
    'permission-edit-any-role': "Edit Any Role",
    'permission-edit-api-collection': "Edit Api Collection",
    'permission-edit-client': "Edit Client",
    'permission-edit-datasource': "Edit Datasource",
    'permission-edit-environment': "Edit Environment",
    'permission-edit-kpi': "Edit KPI",
    'permission-edit-profile': "Edit Profile",
    'permission-edit-resource': "Edit Resource",
    'permission-edit-role': "Edit Role",
    'permission-edit-service-account': "Edit Service Account",
    'permission-edit-template-attributes': "Edit Template Attributes",
    'permission-edit-template-client': "Edit Template Client",
    'permission-edit-template-resource': "Edit Template Resource",
    'permission-edit-template-version': "Edit Template Version",
    'permission-edit-user': "Edit User",
    'permission-edit-user-profile': "Edit User Profile",
    'execute-intellisense-permission': "Execute Intellisense Inference",
    'permission-export-profile': "Export Profile",
    'permission-fetch-swagger': "Fetch Swagger Contract",
    'permission-get-details-agent': "Get Agent Details",
    'permission-get-agent-runtime-info': "Get Agent Runtime Info",
    'permission-get-all-users': "Get All Users",
    'permission-get-permissions': "Get Permissions",
    'permission-get-runtime-info-agent': "Get Runtime Data from Agent",
    'permission-import-profile': "Import Profile",
    'permission-interceptor-init': "Init Biz Interceptor",
    'permission-interceptor-sync': "Sync Biz Interceptor",
    'permission-ipapi-remote-geolocation': "Perform IP-based geolocation",
    'permission-list-agent': "List Agent",
    'permission-manage-any-role-permissions': "Manage Any Role Permissions",
    'permission-manage-role-permissions': "Manage Role Permissions",
    'permission-ping-agent': "Ping Agent",
    'permission-query-data': "Query Data",
    'permission-read-bmel-functions': "Read BMEL Functions",
    'permission-resend-confirmation-email': "Resend Confirmation Email",
    'permission-restart-agent': "Restart Agent",
    'permission-run-report': "Run Report",
    'permission-sa-login': "Service Account Login",
    'permission-sa-logout': "Service Account Logout",
    'permission-send-email': "Send an Email message",
    'permission-send-sms': "Send an SMS Message",
    'permission-2fa-token-generation-sms': "Send a two-factor SMS validation token",
    'permission-2fa-token-validation-sms': "Validate a two-factor SMS validation token",
    'permission-stop-agent': "Stop Agent",
    'permission-sync-agent': "Sync Agent",
    'permission-toggle-all-users': "Toggle All Users",
    'tv-permission-publish': "TV Publish",
    'tv-permission-retire': "TV Retire",
    'tv-permission-review-approve': "TV Approve Review",
    'tv-permission-review-reject': "TV Reject Review",
    'tv-permission-submit-review': "TV Submit for Review",
    'permission-update-biz-event': "Update Business Event",
    'permission-update-biz-interceptor': "Update Biz Interceptor",
    'permission-user-login': "User Login",
    'permission-user-logout': "User Logout",
    'permission-view-account': "View Account",
    'permission-view-agent-logs': "View Agent Logs",
    'permission-view-agent-metrics': "View Agent Metrics",
    'permission-view-agent-panel': "View Agent Panel",
    'permission-view-all-notification': "View All Notifications",
    'permission-view-any-account': "View Any Account",
    'permission-view-any-api-collection': "View Any Api Collection",
    'permission-view-any-profile': "View Any Profile",
    'permission-view-any-role': "View Any Role",
    'permission-view-any-service-account': "View Any Service Account",
    'permission-view-any-template': "View Any Template",
    'permission-view-api-collection': "View Api Collection",
    'permission-view-biz-event': "View Business Events",
    'permission-view-biz-interceptor': "View Biz Interceptors",
    'permission-view-client': "View Client",
    'permission-view-datasource': "View Datasource",
    'permission-view-full-profile': "View Full Profile",
    'permission-view-notification': "View Notification",
    'permission-view-profile': "View Profile",
    'permission-view-report': "View Report",
    'permission-view-resource': "View Resource",
    'permission-view-role': "View Role",
    'permission-view-service-account': "View Service Account",
    'permission-view-system-job': "View System Jobs",
    'permission-view-system-job-details': "View System Job Details",
    'permission-view-template': "View Template",
    'permission-view-template-hierarchy': "View Template Hierarchy",
    'permission-view-user': "View User",
    'permission-view-user-profile': "View User Profile"
  });
